export default __webpack_public_path__ + "static/media/tableau-new.36a30089.png";